import { useState, useCallback } from 'react';
import { authenticatedFetch } from '../../../../utils/api';

const ERROR_MESSAGES = {
    50001: 'Parent occurrence not found.',
    50002: 'Selected form not found.',
    50003: 'One or more questions do not belong to the selected form.',
    50004: 'Duplicate question IDs detected in answers.',
};

export const useFollowUpOccurrence = () => {
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const [submitSuccess, setSubmitSuccess] = useState(null);

    const submitFollowUp = useCallback(async (payload) => {
        setSubmitting(true);
        setSubmitError(null);
        setSubmitSuccess(null);
        try {
            const res = await authenticatedFetch('/ManagerReport/CreateFollowUpOccurrence', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!res.ok) {
                const msg = ERROR_MESSAGES[data.errorCode] || data.message || 'Failed to create follow-up.';
                setSubmitError(msg);
                return null;
            }

            setSubmitSuccess(data.newOccurrenceID);
            return data.newOccurrenceID;
        } catch (ex) {
            setSubmitError(ex.message || 'An unexpected error occurred.');
            return null;
        } finally {
            setSubmitting(false);
        }
    }, []);

    const clearError = useCallback(() => setSubmitError(null), []);

    return { submitting, submitError, submitSuccess, submitFollowUp, clearError };
};
